import React, { Fragment, useEffect, useContext, useState } from "react";
import AddIcon from "../../images/add.svg";
import { Grid, Button } from "@mui/material";
import { Table, TableBody } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { DialogActions, Divider, InputBase } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import ProjectContext from "../../context/project/ProjectContext";
import AddIntelliFiberClientGroup from "./AddIntelliFiberClientsGroup";

const IntelliFiberClientGroupConfiguration = () => {
  const [showTable, setShowTable] = useState(false);
  const [openAddClientUser, setOpenAddClientUser] = React.useState(false);
  const [selectedClientUser, setSelectedClientUser] = React.useState<any>(null);
  const [deleteDialog, setDeleteDialog] = React.useState(false);
  const [globalSearch, setGlobalSearch] = React.useState("");
  const [filteredClientList, setFilteredClientList] = React.useState<any>([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState({ type: "", msg: "" });

  const { loading, clientGroup, getClientGroups, deleteClientGroup } =
    useContext(ProjectContext);

  const closeAlert = () => {
    setAlertMsg({ type: "", msg: "" });
    setShowAlert(false);
  };

  const handleDeleteClientGroup = async (clientGroup) => {
    // console.log("deleteUser props", clientGroup);
    if (clientGroup && deleteClientGroup) {
      try {
        let res = await deleteClientGroup(clientGroup);
        // console.log("deleteUser res", res);

        setAlertMsg({
          type: "Success",
          msg: "Client Group successfully deleted",
        });
        setShowAlert(true);
        setDeleteDialog(false);
        setSelectedClientUser(null);
      } catch (error) {
        console.log("deleteUser err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const closeDelete = () => {
    setSelectedClientUser(null);
    setDeleteDialog(false);
  };

  const editClientGroup = (user) => {
    // console.log("editClientGroup props", user);
    setSelectedClientUser(user);
    setOpenAddClientUser(true);
  };

  const handleShowAddClientUser = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setOpenAddClientUser(true);
  };

  const handleAddClientUserClose = () => {
    setOpenAddClientUser(false);
    setSelectedClientUser(null);
  };

  useEffect(() => {
    // console.log("globalSearch", globalSearch, clientGroup);
    if (clientGroup) {
      let _filteredClientList: any[] = [];
      if (globalSearch) {
        _filteredClientList = clientGroup.filter((ele) =>
          ele.GroupName.toLocaleLowerCase().includes(
            globalSearch.toLocaleLowerCase()
          )
        );
      } else {
        _filteredClientList = [...clientGroup];
      }
      // console.log("globalSearch", _filteredClientList);
      // let sortList =  Object.keys(userRoles).sort((ele)=>{

      // })
      setFilteredClientList(_filteredClientList);
    }
  }, [clientGroup, globalSearch]);

  const fetchClientGroup = async () => {
    if (getClientGroups) {
      setShowTable(false);
      try {
        const res = await getClientGroups();
        setShowTable(true);
      } catch (error) {
        console.log("fetchClientGroup err", error);
        setShowTable(false);
      }
    }
  };

  useEffect(() => {}, [clientGroup]);

  useEffect(() => {
    fetchClientGroup();
  }, []);

  return (
    <Fragment>
      <Grid
        container
        rowSpacing={2}
        columnSpacing={4}
        justifyContent="space-between"
        sx={{ mx: 2, marginBottom: 2, height: "15vh" }}
      >
        <Grid item>
          <Button
            sx={{ maxHeight: "50px" }}
            onClick={handleShowAddClientUser}
            color="secondary"
            variant="contained"
          >
            <img src={AddIcon} alt="Add Client" />
            Add Client Group
          </Button>
        </Grid>
        <Grid item sm={4} sx={{ mx: 4 }}>
          <Paper
            component="form"
            sx={{
              my: 1,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 300,
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search by Client Group Name"
              value={globalSearch}
              onChange={(e) => setGlobalSearch(e.target.value)}
            />

            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
      </Grid>
      {showTable ? (
        <Grid container sx={{ mx: 2, px: 2, minHeight: "50vh" }}>
          <TableContainer
            component={Paper}
            sx={{
              mx: 2,
              px: 2,
              // maxHeight: "50vh",
            }}
          >
            <Table aria-label="client group table" stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontSize: "large" }}
                    align="left"
                    // sortDirection={orderBy === headCell.id ? order : false}
                  >
                    Client Group Name
                  </TableCell>
                  <TableCell sx={{ fontSize: "large" }} align="left">
                    Clients
                  </TableCell>
                  <TableCell sx={{ fontSize: "large" }} align="left">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!filteredClientList
                  ? null
                  : filteredClientList.map((item) => (
                      <TableRow key={item.clientName}>
                        <TableCell align="left">{item.GroupName}</TableCell>
                        <TableCell align="left">
                          {item.Clients.map((ele) => ele.ClientName).join(
                            " , "
                          )}
                        </TableCell>
                        <TableCell align="left" sx={{ display: "flex" }}>
                          <IconButton color="primary">
                            <EditIcon onClick={() => editClientGroup(item)} />
                          </IconButton>
                          <IconButton color="primary">
                            <DeleteIcon
                              onClick={() => {
                                setSelectedClientUser(item);
                                setDeleteDialog(true);
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      ) : (
        <Grid
          container
          className="center-pane"
          justifyContent="center"
          sx={{ mx: 2, px: 2 }}
        >
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            {loading ? "Loading...Please wait!" : "No Records Found"}
          </div>
        </Grid>
      )}
      {openAddClientUser && (
        <AddIntelliFiberClientGroup
          showDialog={openAddClientUser}
          selectedClientGroup={selectedClientUser}
          handleClose={handleAddClientUserClose}
          refresh={fetchClientGroup}
        />
      )}
      {
        //alert dialog
        <Dialog open={showAlert} onClose={closeAlert}>
          <DialogTitle>{alertMsg.type}</DialogTitle>
          <DialogContent>{alertMsg.msg}</DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={closeAlert}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      }
      {
        //confirm delete dialog
        <Dialog open={deleteDialog} onClose={closeDelete}>
          <DialogTitle>Confirmation</DialogTitle>
          <DialogContent>Are you sure you want to delete?</DialogContent>
          <DialogActions>
            <Button onClick={closeDelete}>No</Button>
            <Button
              variant="contained"
              onClick={() => handleDeleteClientGroup(selectedClientUser)}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Fragment>
  );
};

export default IntelliFiberClientGroupConfiguration;
